<script>
import ModalCourseSubjectTestComponent from '../../features/modals/ModalCourseSubjectTestComponent';
import ModalCourseSubjectTestQuestionView from './ModalCourseSubjectTestQuestionView';
import FileSectionView from '../details/FileSectionView';
import draggable from 'vuedraggable';

export default {
  name: 'ModalCourseSubjectTestView',
  components: {
    'modal-test-question-view': ModalCourseSubjectTestQuestionView,
    'file-section-view': FileSectionView,
    draggable,
  },
  extends: ModalCourseSubjectTestComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Examen"
      width="55%"
      class="course-subject-test-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Información de Examen</legend>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="20"
              :md="20"
              :lg="20"
              :xl="20"
            >
              <el-form-item
                label="Título"
                prop="title"
              >
                <el-input
                  v-model="formData.title"
                  maxlength="120"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="4"
              :md="4"
              :lg="4"
              :xl="4"
            >
              <el-form-item
                label="Orden"
                prop="sort"
              >
                <el-input-number
                  v-model="formData.sort"
                  size="small"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item label="¿Es Obligatorio?">
                <el-switch
                  v-model="formData.isRequired"
                  active-color="#13ce66"
                  active-text="SI"
                  inactive-text="NO"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item label="¿Es Cronometrado?">
                <el-switch
                  v-model="formData.isTimer"
                  active-color="#13ce66"
                  active-text="SI"
                  inactive-text="NO"
                  @change="isTimerChange"
                />
              </el-form-item>
            </el-col>
            
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item
                label="Tipo de Cronometrado"
                prop="timerType"
              >
                <el-select
                  v-model="formData.timerType"
                  clearable
                  filterable
                  placeholder="Seleccionar"
                  value-key="id"
                  size="small"
                  :disabled="!formData.isTimer"
                  @change="isTimerTypeChange"
                >
                  <el-option
                    v-for="item in timerTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item
                label="Duración Total(Min.)"
                prop="duration"
              >
                <el-input-number
                  v-model="formData.duration"
                  size="small"
                  :disabled="!isTestTimeType"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="course-section-header">
            <div class="title-icon">
              <h3 class="title">
                <i class="uil uil-layers" /> Secciones del Examen
              </h3>
            </div>
            <el-button
              type="primary"
              size="small"
              class="btn-primary"
              icon="el-icon-circle-plus"
              @click="onAddTestActivity"
            >
              Agregar Sección
            </el-button>
          </div>

          <!-- Empty State -->
          <div
            v-if="!hasVisibleTestActivities()"
            class="test-sections-empty"
          >
            <el-empty
              :image-size="65"
              description="No hay secciones configuradas en este examen todavía."
            >
              <el-button
                type="primary"
                size="small"
                class="btn-primary"
                icon="el-icon-circle-plus"
                @click="onAddTestActivity"
              >
                Agregar Primera Sección
              </el-button>
            </el-empty>
          </div>

          <!-- Sections Collapse -->
          <div
            v-else
            v-loading="isSectionLoading"
            class="test-sections-wrapper"
          >
            <el-collapse
              v-model="activeCollapseIndex"
              accordion
              class="test-sections-collapse"
            >
              <el-collapse-item
                v-for="(section, indexSection) in formData.getTestActivities()"
                :key="indexSection"
                :name="indexSection"
                class="test-collapse-item"
              >
                <template #title>
                  <div class="collapse-title-row">
                    <div class="title-left">
                      <span class="section-order-badge">{{ indexSection + 1 }}</span>
                      <span class="section-title-label">
                        {{ section.description || ('Sección ' + (indexSection + 1)) }}
                      </span>
                    </div>
                    <div class="title-right">
                      <el-tag
                        size="small"
                        type="info"
                        effect="plain"
                        class="badge-questions-count"
                      >
                        <i class="uil uil-question-circle" />
                        {{ getSectionQuestionsCount(section) }} {{ getSectionQuestionsCount(section) === 1 ? 'pregunta' : 'preguntas' }}
                      </el-tag>
                      <el-button
                        size="small"
                        class="btn-row-action btn-row-delete"
                        title="Eliminar sección"
                        @click.stop="onDeleteTestActivity(indexSection)"
                      >
                        <i
                          class="el-icon-delete"
                          aria-hidden="true"
                        />
                      </el-button>
                    </div>
                  </div>
                </template>

                <div class="test-collapse-content">
                  <el-row
                    class="row-bg"
                    :gutter="20"
                  >
                    <el-col
                      :xs="24"
                      :sm="24"
                      :md="16"
                      :lg="16"
                      :xl="16"
                    >
                      <el-form-item
                        label="Título de la Sección"
                        prop="description"
                      >
                        <el-input
                          v-model="section.description"
                          maxlength="120"
                          size="small"
                          :class="'description_editor_' + indexSection"
                          placeholder="Ingrese el título o descripción de la sección"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col
                      :xs="24"
                      :sm="12"
                      :md="8"
                      :lg="8"
                      :xl="8"
                    >
                      <el-form-item
                        label="Duración (Min.)"
                        prop="duration"
                      >
                        <el-input-number
                          v-model="section.duration"
                          size="small"
                          :disabled="!isSectionTimeType"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row
                    class="row-bg"
                    :gutter="20"
                  >
                    <el-col
                      :xs="24"
                      :sm="24"
                      :md="16"
                      :lg="16"
                      :xl="16"
                    >
                      <el-form-item
                        label="Instrucciones"
                        prop="instruction"
                      >
                        <el-input
                          v-model="section.instruction"
                          type="textarea"
                          :rows="2"
                          maxlength="255"
                          size="small"
                          :class="'instruction_editor_' + indexSection"
                          placeholder="Instrucciones para responder esta sección"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col
                      :xs="24"
                      :sm="12"
                      :md="8"
                      :lg="8"
                      :xl="8"
                    >
                      <el-form-item
                        prop="sectionFile"
                        label="Archivo de Sección"
                      >
                        <file-section-view :section="section" />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- Questions Sub-Section Header -->
                  <div class="test-questions-header">
                    <div class="questions-title">
                      <h4>
                        <i class="uil uil-question-circle" /> Preguntas de la Sección
                      </h4>
                      <span class="questions-subtitle">
                        {{ getSectionQuestionsCount(section) }} {{ getSectionQuestionsCount(section) === 1 ? 'pregunta registrada' : 'preguntas registradas' }}
                      </span>
                    </div>
                    <el-button
                      type="primary"
                      size="small"
                      class="btn-primary"
                      icon="el-icon-circle-plus"
                      :disabled="!onCanCreateCourseSubjectQuestion(modulePermissions)"
                      @click="onAddQuestion(indexSection)"
                    >
                      Agregar Pregunta
                    </el-button>
                  </div>

                  <!-- Questions Table or Empty State -->
                  <div class="course-sections-wrapper questions-wrapper">
                    <div
                      v-if="!hasVisibleQuestions(section)"
                      class="course-sections-empty"
                    >
                      <el-empty
                        :image-size="50"
                        description="No hay preguntas asignadas a esta sección todavía."
                      >
                        <el-button
                          type="primary"
                          size="small"
                          class="btn-primary"
                          icon="el-icon-circle-plus"
                          :disabled="!onCanCreateCourseSubjectQuestion(modulePermissions)"
                          @click="onAddQuestion(indexSection)"
                        >
                          Agregar Primera Pregunta
                        </el-button>
                      </el-empty>
                    </div>

                    <div
                      v-else
                      class="course-sections-table"
                    >
                      <div class="sections-table-head">
                        <div class="th-col col-sort">ORDEN</div>
                        <div class="th-col col-title">PREGUNTA</div>
                        <div class="th-col col-answers">RESPUESTAS</div>
                        <div class="th-col col-actions">OPCIONES</div>
                      </div>

                      <draggable
                        v-model="section.courseSubjectTestQuestions"
                        item-key="sort"
                        handle=".drag-handle"
                        ghost-class="ghost-section-row"
                        @change="onChangeDrag(section)"
                      >
                        <template #item="{ element: question, index: indexQuestion }">
                          <div
                            v-show="question.updateState !== formData.UPDATE_STATUS.REMOVED"
                            :key="question.sort || indexQuestion"
                            class="sections-table-row"
                          >
                            <!-- Orden / Drag Handle -->
                            <div class="td-col col-sort">
                              <i
                                class="fa fa-grip-vertical drag-handle"
                                title="Arrastrar para ordenar"
                              />
                              <span class="order-badge">{{ question.sort }}</span>
                            </div>

                            <!-- Pregunta Descripción (HTML render) -->
                            <div class="td-col col-title">
                              <div
                                class="section-title-text question-content"
                                v-html="question.description"
                              />
                            </div>

                            <!-- Respuestas -->
                            <div class="td-col col-answers">
                              <el-tag
                                size="small"
                                type="primary"
                                effect="plain"
                              >
                                <i class="uil uil-list-ul" />
                                {{ question.getTotalAnswers ? question.getTotalAnswers() : 0 }} respuestas
                              </el-tag>
                            </div>

                            <!-- Opciones -->
                            <div class="td-col col-actions">
                              <el-dropdown
                                trigger="click"
                                @command="onChangeItemOptions"
                              >
                                <el-button
                                  size="small"
                                  class="btn-row-action"
                                >
                                  <i class="fa fa-ellipsis-v" />
                                </el-button>
                                <template #dropdown>
                                  <el-dropdown-menu>
                                    <el-dropdown-item
                                      :command="{
                                        command: 'edit',
                                        item: question,
                                        sectionIndex: indexSection,
                                        index: indexQuestion,
                                      }"
                                      :disabled="!onCanReadCourseSubjectQuestion(modulePermissions)"
                                    >
                                      <i
                                        class="el-icon-edit"
                                        aria-hidden="true"
                                      />
                                      Mostrar
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                      :command="{
                                        command: 'delete',
                                        item: question,
                                        sectionIndex: indexSection,
                                        index: indexQuestion,
                                      }"
                                      :disabled="!onCanDeleteCourseSubjectQuestion(modulePermissions)"
                                    >
                                      <i
                                        class="el-icon-delete"
                                        aria-hidden="true"
                                      />
                                      Eliminar
                                    </el-dropdown-item>
                                  </el-dropdown-menu>
                                </template>
                              </el-dropdown>
                            </div>
                          </div>
                        </template>
                      </draggable>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </fieldset>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Aceptar</el-button>
        </span>
      </template>
    </el-dialog>
    <modal-test-question-view
      v-if="modalItemQuestion.isVisible"
      :form-data="itemQuestion"
      :conf="modalItemQuestion"
    />
  </div>
</template>
